import { render } from "./Expert.vue?vue&type=template&id=f19d3638&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"

import "./Expert.vue?vue&type=style&index=0&id=f19d3638&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19d3638"]])

export default __exports__